// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type ResourcesAnalyticsQueryVariables = PrivateSchemaTypes.Exact<{
  filter: PrivateSchemaTypes.AnalyticsFilterWithGroups;
  chartTimeUnit: PrivateSchemaTypes.TimeUnitEnum;
}>;


export type ResourcesAnalyticsQuery = (
  { __typename?: 'Query' }
  & { analytics: (
    { __typename?: 'AnalyticsModel' }
    & { resources: (
      { __typename?: 'AnalyticsResourcesModel' }
      & Pick<PrivateSchemaTypes.AnalyticsResourcesModel, 'averageRating' | 'uniqueViewedTopicsCount' | 'totalViewsCount'>
      & { topicViewsByTimeUnit: Array<(
        { __typename?: 'AnalyticsHitCountByTimeUnit' }
        & Pick<PrivateSchemaTypes.AnalyticsHitCountByTimeUnit, 'count' | 'day'>
      )>, ratingSpread: Array<(
        { __typename?: 'AnalyticsRatingSpreadModel' }
        & Pick<PrivateSchemaTypes.AnalyticsRatingSpreadModel, 'rating' | 'count'>
      )> }
    ), workbooks: (
      { __typename?: 'AnalyticsWorkbooksModel' }
      & Pick<PrivateSchemaTypes.AnalyticsWorkbooksModel, 'completedCount' | 'workbooksCount' | 'passedWorkbooksInPercents'>
    ) }
  ) }
);

export type ResourcesOverviewTableQueryVariables = PrivateSchemaTypes.Exact<{
  mainAnalyticsFilter: PrivateSchemaTypes.AnalyticsFilterWithGroups;
  resourcesOverviewFilter: PrivateSchemaTypes.AnalyticsResourcesFilter;
}>;


export type ResourcesOverviewTableQuery = (
  { __typename?: 'Query' }
  & { analytics: (
    { __typename?: 'AnalyticsModel' }
    & { resources: (
      { __typename?: 'AnalyticsResourcesModel' }
      & Pick<PrivateSchemaTypes.AnalyticsResourcesModel, 'resourcesCount'>
      & { resourcesOverview: Array<(
        { __typename?: 'AnalyticsViewsCountByTopicModel' }
        & Pick<PrivateSchemaTypes.AnalyticsViewsCountByTopicModel, 'viewsCount' | 'passRate'>
        & { topic: (
          { __typename?: 'TopicModelAsEditor' }
          & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id' | 'currentTitle' | 'total_rating' | 'number_rated' | 'averageRating' | 'deleted_at' | 'lastViewedAt' | 'production_topic_version_id'>
          & { workspace?: PrivateSchemaTypes.Maybe<(
            { __typename?: 'WorkspaceModelAsCollaborator' }
            & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'name' | 'id'>
          )>, author: (
            { __typename?: 'UserModelPublicBase' }
            & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name' | 'first_name' | 'last_name' | 'email' | 'image_url'>
          ) }
        ) }
      )> }
    ) }
  ) }
);


export const ResourcesAnalyticsDocument = gql`
    query ResourcesAnalytics($filter: AnalyticsFilterWithGroups!, $chartTimeUnit: TimeUnitEnum!) {
  analytics(filter: $filter) {
    resources {
      topicViewsByTimeUnit(unit: $chartTimeUnit) {
        count
        day
      }
      ratingSpread {
        rating
        count
      }
      averageRating
      uniqueViewedTopicsCount
      totalViewsCount
    }
    workbooks {
      completedCount
      workbooksCount
      passedWorkbooksInPercents
    }
  }
}
    `;

/**
 * __useResourcesAnalyticsQuery__
 *
 * To run a query within a React component, call `useResourcesAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesAnalyticsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      chartTimeUnit: // value for 'chartTimeUnit'
 *   },
 * });
 */
export function useResourcesAnalyticsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ResourcesAnalyticsQuery, ResourcesAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResourcesAnalyticsQuery, ResourcesAnalyticsQueryVariables>(ResourcesAnalyticsDocument, options);
      }
export function useResourcesAnalyticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResourcesAnalyticsQuery, ResourcesAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResourcesAnalyticsQuery, ResourcesAnalyticsQueryVariables>(ResourcesAnalyticsDocument, options);
        }
export type ResourcesAnalyticsQueryHookResult = ReturnType<typeof useResourcesAnalyticsQuery>;
export type ResourcesAnalyticsLazyQueryHookResult = ReturnType<typeof useResourcesAnalyticsLazyQuery>;
export type ResourcesAnalyticsQueryResult = Apollo.QueryResult<ResourcesAnalyticsQuery, ResourcesAnalyticsQueryVariables>;
export const ResourcesOverviewTableDocument = gql`
    query ResourcesOverviewTable($mainAnalyticsFilter: AnalyticsFilterWithGroups!, $resourcesOverviewFilter: AnalyticsResourcesFilter!) {
  analytics(filter: $mainAnalyticsFilter) {
    resources {
      resourcesOverview(overviewTableFilter: $resourcesOverviewFilter) {
        viewsCount
        passRate
        topic {
          id
          currentTitle
          total_rating
          number_rated
          averageRating
          deleted_at
          lastViewedAt
          production_topic_version_id
          workspace {
            name
            id
          }
          author {
            id
            display_name
            first_name
            last_name
            email
            image_url
          }
        }
      }
      resourcesCount(overviewTableFilter: $resourcesOverviewFilter)
    }
  }
}
    `;

/**
 * __useResourcesOverviewTableQuery__
 *
 * To run a query within a React component, call `useResourcesOverviewTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesOverviewTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesOverviewTableQuery({
 *   variables: {
 *      mainAnalyticsFilter: // value for 'mainAnalyticsFilter'
 *      resourcesOverviewFilter: // value for 'resourcesOverviewFilter'
 *   },
 * });
 */
export function useResourcesOverviewTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ResourcesOverviewTableQuery, ResourcesOverviewTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResourcesOverviewTableQuery, ResourcesOverviewTableQueryVariables>(ResourcesOverviewTableDocument, options);
      }
export function useResourcesOverviewTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResourcesOverviewTableQuery, ResourcesOverviewTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResourcesOverviewTableQuery, ResourcesOverviewTableQueryVariables>(ResourcesOverviewTableDocument, options);
        }
export type ResourcesOverviewTableQueryHookResult = ReturnType<typeof useResourcesOverviewTableQuery>;
export type ResourcesOverviewTableLazyQueryHookResult = ReturnType<typeof useResourcesOverviewTableLazyQuery>;
export type ResourcesOverviewTableQueryResult = Apollo.QueryResult<ResourcesOverviewTableQuery, ResourcesOverviewTableQueryVariables>;